import React from 'react';

import { AppSkeleton, BankDetails, Earnings } from '@/component';
import { TabLayout } from '@/kaya';

import styles from './Financial.module.scss';

const Financial = () => (
  <AppSkeleton>
    <div className={styles.Financial}>
      <h1 className={styles.heading}>Financial</h1>
      <TabLayout
        tabs={[{ label: 'Earnings' }, { label: 'Bank Details' }]}
        width="100%"
        tabsContent={[<Earnings key={1} />, <BankDetails key={2} />]}
        tabHeaderClassName={styles.tab}
      />
    </div>
  </AppSkeleton>
);

export default Financial;
